(ns frontend.view.grid.surveys-grid.download-modal.view
  (:require [common.localization :as loc]
            [ui.components.modal.view :as modal]))

(defn body
  []
  [:div
   {:class "flex flex-col gap-4 align-items-center py-20"}
   [:i
    {:class "fal fa-file animate-spin text-[96px]"}]
   ])

(defn footer
  []
  [:div
   {:class "flex flex-row flex-auto"}])

(defn view
  [visible?]
  [modal/view
   {:visible? visible?
    :size     :full}
   (loc/tr :processing)
   [body]
   nil])
